import { Button, message, Modal, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { fetchAPI } from '../../utils/api';
import useTable from '../../components/Template/TableTemplate';
import { CheckCircleTwoTone } from '@ant-design/icons';

const SearchJDProduct = ({
  quantity = 1,
  disable = false,
  defaultValue = null,
  onChange = value => {},
  complete_data = false,
  address = '',
}) => {
  const [loading, setLoading] = useState(false);
  const [labelButton, setLabelButton] = useState('Select JD Product');
  const getJDProductInfo = async defaultValue => {
    try {
      setLoading(true);
      const res = await fetchAPI(`product/jd-direct/${defaultValue}`);
      setLabelButton(`[${res.external_id}] ${res.name} (CNY ${res.price})`);
    } catch (error) {
      setLabelButton('Select JD Product');
      message.error(`Cannot read JD Product info: ${error}`);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (defaultValue) {
      getJDProductInfo(defaultValue);
    } else {
      setLabelButton('Select JD Product');
    }
  }, [defaultValue]); // eslint-disable-line

  useEffect(() => {
    toggleLoad();
  }, [quantity, address]); // eslint-disable-line
  // eslint-disable-next-line
  const [table, toggleLoad] = useTable({
    extraPayload: { address: address, qty: quantity },
    updateQueryParams: false,
    useSearchVCard: false,
    useFilterCreatedBy: false,
    useInternalPurchase: false,
    paginationPosition: 'bottom',
    showDateRange: false,
    showDownload: false,
    url: 'product/jd-direct',
    method: 'POST',
    columns: [
      {
        title: 'Actions',
        render: record => (
          <Button
            shape="circle"
            icon={<CheckCircleTwoTone twoToneColor="#52c41a" />}
            onClick={() => {
              setLabelButton(
                `[${record.external_id}] ${record.name} (CNY ${record.price})`
              );
              onChange(complete_data ? record : record.external_id);
              setOpen(false);
            }}
          />
        ),
      },
      {
        title: 'External ID',
        key: 'external_id',
        dataIndex: 'external_id',
      },
      {
        title: 'Name',
        key: 'name',
        dataIndex: 'name',
      },
      {
        title: 'Price (CNY)',
        key: 'price',
        dataIndex: 'price',
      },
      {
        title: 'Stock',
        key: 'stock',
        dataIndex: 'stock',
      },
    ],
  });
  const [open, setOpen] = useState(false);

  return (
    <>
      {!disable ? (
        <Spin spinning={loading}>
          <Button
            style={{ height: 'auto' }}
            type="primary"
            onClick={() => setOpen(true)}
          >
            <span style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
              {labelButton}
            </span>
          </Button>
        </Spin>
      ) : (
        <span>{labelButton}</span>
      )}
      <Modal
        title="Select JD Product"
        centered
        visible={open}
        width={'90%'}
        onCancel={() => setOpen(false)}
        footer={
          <button onClick={() => setOpen(false)} style={{ cursor: 'pointer' }}>
            Cancel
          </button>
        }
      >
        {table}
      </Modal>
    </>
  );
};

export default SearchJDProduct;
